import { useRouter } from 'next/router';
import styles from './index.module.scss';
import FirstKv from './components/firstKv';
import PageCountDown from './components/PageCountDown';
import TimeLine from './components/TimeLine';
import KRTabs from './components/KRTabs';
import AnchorTabs from './components/AnchorTabs';
import { MUTI_AREA_ARR } from '@/componentsH5/EcoCreditsDay/components/AnchorTabs/constant';

export default function EcoCreditsDay() {
    const { locale } = useRouter();

    return (
        <div className={styles.ecoCreditsDay}>
            <FirstKv />
            {['jp', 'kr'].includes(locale as keyof typeof locale) && <PageCountDown />}
            {locale !== 'au' && <TimeLine />}
            {['jp', 'kr'].includes(locale as keyof typeof locale) && <KRTabs />}
            {MUTI_AREA_ARR.includes(locale as keyof typeof locale) && <AnchorTabs />}
        </div>
    );
}
